export default __webpack_public_path__ + "static/media/retreat-img1.7c850a9a.png";